var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E0F5",
    d: "M16.285 8.023C16.28 3.754 12.773.247 8.505.242 4.234.236.736 3.735.742 8.004a7.73 7.73 0 0 0 7.726 7.727c4.27.005 7.823-3.439 7.817-7.708m-8.533 3.82L7.748 8.78l-3.065-.004-.002-1.532 3.065.003-.003-3.065 1.532.002.004 3.065 3.065.004.002 1.533L9.28 8.78l.004 3.065z"
  })));
};
export default SvgPlus;